import React from 'react';
import { Avatar, AvatarsGroup, Modal } from '@mantine/core';

import { ReactComponent as CrossIcon } from 'assets/icons/crossIcon.svg';
import { ReactComponent as LowPriorityIcon } from 'assets/icons/lowPriorityIcon.svg';
import { ReactComponent as HighPriorityIcon } from 'assets/icons/highPriorityIcon.svg';
import { ReactComponent as MediumPriorityIcon } from 'assets/icons/mediumPriorityIcon.svg';
import { ReactComponent as TimeIcon } from 'assets/icons/timeIcon.svg';
import { ReactComponent as TeamIcon } from 'assets/icons/teamIcon.svg';
import dayjs from 'dayjs';

export default function ViewProjectModal({
  isModalOpen,
  setIsModalOpen,
  projectDetails,
}) {
  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <Modal
        opened={isModalOpen}
        onClose={() => closeModal(false)}
        title={''}
        withCloseButton={false}
        overlayColor={'#F8F7F799'}
        overlayBlur={20}
        overlayOpacity={0.5}
        centered
        size='lg'
        radius='md'
        overflow='inside'
        transitionDuration={100}
        classNames={{
          title: 'w-full text-333333 font-semibold text-xl text-center',
          modal: 'pl-10',
          body: 'scroller -mr-4 pr-2',
        }}
      >
        <div>
          <CrossIcon
            className='w-12 ml-auto -mt-4 cursor-pointer'
            onClick={() => closeModal()}
          />
          <div className='flex justify-center space-x-6 items-center -mt-6'>
            <Avatar src={''} color='red' size={60} radius='xl'>
              {projectDetails?.title[0]?.toUpperCase()}
            </Avatar>
            <p className='text-xl font-semibold text-333333'>
              {projectDetails?.title}
            </p>
          </div>
          <p className='text-gray3'>{projectDetails?.description}</p>
          <div className='flex justify-between items-center mr-4 mt-8'>
            <div className='flex space-x-3 items-center text-gray3 pl-5 '>
              <TimeIcon />
              <p>
                Due date -{' '}
                {dayjs(projectDetails?.to_date).format('DD MMM YYYY')}{' '}
              </p>
            </div>
            <div className='flex items-center space-x-1'>
              {projectDetails?.priority === 'High' ? (
                <HighPriorityIcon />
              ) : projectDetails?.priority === 'Medium' ? (
                <MediumPriorityIcon />
              ) : (
                <LowPriorityIcon />
              )}
              <p
                className={`${
                  projectDetails?.priority === 'Medium'
                    ? 'text-success'
                    : projectDetails?.priority === 'High'
                    ? 'text-[#FB0C0C]'
                    : 'text-warning'
                } font-bold`}
              >
                {projectDetails?.priority}
              </p>
            </div>
          </div>
          <div className='flex space-x-2 items-center my-4'>
            <Avatar
              src={projectDetails?.lead__profile_picture}
              color='red'
              size={60}
              radius='xl'
            >
              {projectDetails?.lead__user__first_name[0]?.toUpperCase()}
            </Avatar>
            <div>
              <p className='font-semibold text-gray2'>
                {projectDetails?.lead__user__first_name}
              </p>
              <p className='text-sm text-gray3'>
                {projectDetails?.lead__designation__name}
              </p>
            </div>
          </div>

          <div className='flex space-x-3 items-center justify-between text-gray3 pl-5 mr-4'>
            <div className='flex space-x-3 items-center'>
              <TeamIcon />
              <AvatarsGroup
                limit={3}
                total={projectDetails?.members?.length}
                classNames={{
                  truncated: 'bg-FFE8E1',
                }}
              >
                {projectDetails?.members?.map((member) => (
                  <Avatar
                    src={member?.employee__profile_picture}
                    color={'red'}
                    radius='xl'
                    size={'xl'}
                    key={member?.id}
                  >
                    {member?.employee__user__first_name[0].toUpperCase()}
                  </Avatar>
                ))}
              </AvatarsGroup>
            </div>
            <div>
              <p
                className={`${
                  projectDetails?.status === 'Not yet started'
                    ? 'text-[#DD0F1B]'
                    : projectDetails?.status === 'In progress'
                    ? 'text-warning'
                    : 'text-success'
                } text-xs text-right pb-1.5 font-bold`}
              >
                {projectDetails?.status}
              </p>
              <div className='flex space-x-1'>
                <span
                  className={`${
                    projectDetails?.status === 'Not yet started'
                      ? 'bg-[#E0E0E0]'
                      : 'bg-primary'
                  } w-10 h-1.5 rounded-full`}
                ></span>
                <span
                  className={`${
                    projectDetails?.status === 'Not yet started' ||
                    projectDetails?.status === 'In progress'
                      ? 'bg-[#E0E0E0]'
                      : 'bg-primary'
                  } w-10 h-1.5 rounded-full`}
                ></span>
                <span
                  className={`${
                    projectDetails?.status === 'Completed'
                      ? 'bg-primary'
                      : 'bg-[#E0E0E0]'
                  } w-10 h-1.5 rounded-full`}
                ></span>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
